/* eslint-disable max-params,no-empty-function */
import axios from 'axios';
import { objectToFormData } from 'object-to-formdata';
import joinUrl from 'proper-url-join';

const CancelToken = axios.CancelToken;
let cancel;

class Client {
    /**
     *
     * @param params
     * @constructor
     */
    constructor(params) {
        this.baseURL = params.baseURL;
        this.leadingSlash = params.leadingSlash;
        this.trailingSlash = params.trailingSlash;
        this._transport = axios;
    }

    /**
     *
     * @param method
     * @param url
     * @param data
     * @param headers
     * @param uploadProgressCallback
     * @param withCredentials
     * @returns {*}
     */
    send(method, url, data, headers = {}, uploadProgressCallback, withCredentials = true) {
        const callURL = joinUrl(this.baseURL, url, {
            leadingSlash: this.leadingSlash,
            trailingSlash: this.trailingSlash
        });
        const params = {};
        const dataIsObject = typeof data === 'object' && Object.keys(data).length && data.constructor === Object;

        const headersObj = JSON.parse(JSON.stringify(headers)) || {};

        let body = '';

        if (method === 'POST' || method === 'PUT') {
            body = data;
            headersObj['Content-Type'] = 'application/json';
            if (data instanceof FormData) {
                headersObj['Content-Type'] = 'multipart/form-data';
            }
        } else if (method === 'DELETE') {
            if (dataIsObject) {
                body = new URLSearchParams();
                Object.entries(data).forEach(item => {
                    body.append(item[0], item[1]);
                });
                headersObj['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
            }

        } else if (dataIsObject) {
            Object.assign(params, data);
        }

        this.onRequestStart(callURL, method, body, headersObj);

        return this._transport(callURL, {
            method,
            data: body,
            headers: headersObj,
            params,
            timeout: 50 * 1000,
            withCredentials,
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            }),
            onUploadProgress: progressEvent => {
                if (uploadProgressCallback) {
                    uploadProgressCallback(progressEvent);
                }
            },
            validateStatus: status => status >= 200 && status <= 202
        })
            .then(response => {
                this.onRequestComplete();
                this.onRequestSuccess(response);

                return response.data;
            })
            .catch(error => {
                this.onRequestComplete();
                this.onRequestError(error.response);

                return Promise.reject(error.response);
            });
    }

    /**
     *
     * @param method
     * @param url
     * @param data
     * @param headers
     * @param uploadProgressCallback
     * @returns {*}
     */
    sendFormData(method, url, data, headers, uploadProgressCallback) {
        return this.send(method, url, objectToFormData(data), headers, uploadProgressCallback);
    }

    /**
     *
     */
    cancel() {
        cancel();
    }

    /**
     *
     * @param url
     * @param requestOptions
     */
    onRequestStart() {
    }

    /**
     *
     * @param response
     */
    onRequestSuccess() {
    }

    /**
     *
     * @param reason
     */
    onRequestError() {
    }

    /**
     *
     */
    onRequestComplete() {
    }

}

export default Client;
